import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { SmallText } from 'ds/components/typography';


export const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing(2)};
  padding: 0 ${({ theme }) => theme.spacing(1)};
`;

export const OptionsWrapper = styled.div`
  ${({ theme }) => `
    width: 100%;
    margin-top: ${theme.spacing(3)};
  `}
`;

export const ReasonTextWrapper = styled.div`
  height: 76px;
`;

export const AgentDescription = styled(SmallText)`
  ${({ theme }) => `
    margin: ${theme.spacing(1.5, 0, 3)};
    color: ${theme.colors.neutrals.grey3};
  `}
`;

export const ConfirmButton = styled(Button)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.colors.alert.red,
  borderColor: theme.colors.alert.red,
  color: theme.colors.neutrals.white,
  '&:hover, &:active': {
    backgroundColor: theme.colors.alert.red,
    borderColor: theme.colors.alert.red,
    color: theme.colors.neutrals.white,
  },
}));
